import * as types from 'constants/ActionTypes';
import { ERROR, SUCCESS } from 'constants/AppConstants';
import i18n from 'i18n';

const initState = {
  isLoading: true,
  loadError: false,
  reportId: null,
  reportDetails: {},
  bluePrintFileData: '',
  uploadBluePrintFileError: '',
  bluePrintIdError: false,
  uploadingBluePrintFile: false,
  bluePrintFileName: '',
  bluePrintFileId: '',
  uploadFileAlert: {
    open: false,
    severity: '',
    title: '',
    message: '',
  },
};

const { t } = i18n;

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.LOADING_UPLOAD_INFORMATION_PAGE:
      return {
        ...state,
        isLoading: true,
        loadError: false,
      };
    case types.LOAD_UPLOAD_INFORMATION_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loadError: false,
        reportId: action.reportId,
        reportDetails: action.reportDetails,
      };
    case types.LOAD_UPLOAD_INFORMATION_PAGE_ERROR:
      return {
        ...state,
        isLoading: false,
        loadError: true,
      };

    case types.UPLOAD_INFORMATION_UPLOADING_BLUEPRINT_FILE: return {
      ...state,
      uploadBluePrintFileError: '',
      uploadingBluePrintFile: true,
      uploadFileAlert: {},
    };
    case types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS: return {
      ...state,
      bluePrintFileData: action.fileData,
      uploadingBluePrintFile: false,
      ...(action.fileId ? { bluePrintFileId: action.fileId } : {}),
      ...(action.fileName ? { bluePrintFileName: action.fileName } : {}),
      uploadFileAlert: {
        open: true,
        severity: SUCCESS,
        message: t('upload_information__upload_success_message'),
      },
    };
    case types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_ERROR: return {
      ...state,
      uploadBluePrintFileError: action.error,
      uploadingBluePrintFile: false,
      uploadFileAlert: {
        open: true,
        severity: ERROR,
        message: t('upload_information__upload_failed_message'),
      },
    };
    case types.UPLOAD_INFORMATION_UPDATE_INSTRUCTIONS: return {
      ...state,
      reportDetails: {
        ...state.reportDetails,
        comments: action.instructions,
      },
    };
    case types.CLEAR_UPLOAD_INFORMATION_DATA: return {
      state: initState,
    };
    case types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_ERROR: return {
      ...state,
      uploadBluePrintFileError: action.error,
      uploadingBluePrintFile: false,
      uploadFileAlert: {
        open: true,
        severity: ERROR,
        message: t('upload_information__upload_save_failure_message'),
      },
    };
    case types.UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_SUCCESS: return {
      ...state,
      uploadFileAlert: {
        open: true,
        severity: SUCCESS,
        message: action.message,
      },
    };
    default:
      return state;
  }
};
